module.exports = __webpack_public_path__ + "0278e61f9de3f861d3381e2065f6672d.MP3";